import React from 'react';

const TruncatedText = ({ text, active }) => {
  const truncated = text?.slice(0, 5); // Réduire la chaîne à 5 caractères

  return active ? <span>{truncated}</span> : <span>{text}</span>;
};

export default TruncatedText;
